import React, { useEffect, useState } from 'react';
import API from '../../utils/ApiConfig';
import Loader from '../common/Loader/Loader';
import { ACCOUNT_SETUP_STATUS } from '../../utils/ApiEndpoints';
import { useTranslation } from 'react-i18next';
import ErrorMessage from '../common/ErrorMessage/ErrorMessage';
import ProgressDialog from '../common/ProgressDialog/ProgressDialog';
import { QBO_ACCOUNT_SETUP_PROGESS_DESTINATION } from '../../utils/WebSocketDestinations';
import { useUnload } from '../../utils/CustomHooks';
import Header from '../Header/Header';

const AccountSetupStatus = props => {
  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const [showProgress, setShowProgress] = useState(false);
  const [destroyProgress, setDestroyProgress] = useState(false);
  useUnload(() => setDestroyProgress(true));

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      showAccountSetupProgress();
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  const showAccountSetupProgress = () => {
    const {
      services: { CommonService },
    } = props;
    setShowProgress(true);
    API.post(ACCOUNT_SETUP_STATUS, {})
      .then(data => {
        setLoading(false);
        setDestroyProgress(true);
        // redirect to Onboarding page
        CommonService.processOnBoardingRedirection()
          .then()
          .catch(err => {
            setErrorMessage(tc_common('ONBOARD_REDIRECT_ERROR'));
            setShowErrorMessage(true);
          });
      })
      .catch(err => {
        err && err.response && err.response.data && setErrorMessage(err.response.data.status);
        setLoading(false);
        setShowErrorMessage(true);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const { t } = useTranslation();

  const tc = (e, data) => (data ? t(`account_setup_status:${e}`, data) : t(`account_setup_status:${e}`));
  const tc_common = (e, data) => (data ? t(`common:${e}`, data) : t(`common:${e}`));

  const closeErrorMessage = () => {
    setShowErrorMessage(false);
  };

  return (
    <div className="accountsetup">
      <ProgressDialog show={showProgress} destroy={destroyProgress} destination={QBO_ACCOUNT_SETUP_PROGESS_DESTINATION} />
      {isLoading ? <Loader /> : ''}

      <ErrorMessage open={showErrorMessage} handleClose={closeErrorMessage} message={errorMessage} />

      <div className="accountsetup-top-section">
        <Header headerIcon="icon-centage-primary-logo" />
        <div className="accountsetup-welcome-card">
          <div className="accountsetup-welcome-title">{tc('PM_WELCOME_TITLE')}</div>
          <div className="accountsetup-welcome-desc">
            {tc('PM_WELCOME_DESC1')} <b>{tc('BUDGET')},</b> <b>{tc('FORECAST')},</b> {tc('PM_WELCOME_DESC2')} <b>{tc('REPORTING')}</b>{' '}
            {tc('PM_WELCOME_DESC3')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSetupStatus;